export const EVENT_MODES = {
  MANUAL: 'MANUAL',
  UPCOMING: 'UPCOMING',
};
